import { render, staticRenderFns } from "./BlockListFactBoxCustom.vue?vue&type=template&id=375df2bd&"
import script from "./BlockListFactBoxCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListFactBoxCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports